import { render, staticRenderFns } from "./EventOwnerDeleteModal.vue?vue&type=template&id=956983e6&"
import script from "./EventOwnerDeleteModal.vue?vue&type=script&lang=js&"
export * from "./EventOwnerDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports